<template>
  <div class="deferral-query">
    <div class="lvyun-profile-banner">
      <h2>延期查询</h2>
      <p>查询顾客延期操作记录，支持按姓名、手机号、操作日期筛选与导出。</p>
    </div>

    <el-card class="action-card" shadow="never">
      <template slot="header">
        <div class="card-header">
          <div class="card-title">延期记录列表</div>
          <div class="header-actions">
            <el-button type="default" size="small" class="btn-secondary" @click="handleExport">
              导出Excel
            </el-button>
          </div>
        </div>
      </template>

      <div class="filters-row">
        <el-input
          v-model="filters.user_name"
          placeholder="顾客姓名"
          clearable
          style="width: 160px;"
          @change="handleSearch"
        />
        <el-input
          v-model="filters.user_phone"
          placeholder="手机号"
          clearable
          style="width: 160px; margin-left: 10px;"
          @change="handleSearch"
        />
        <el-input
          v-model="filters.order_id"
          placeholder="订单 ID"
          clearable
          style="width: 140px; margin-left: 10px;"
          @change="handleSearch"
        />
        <el-select
          v-model="filters.meal_run_status"
          placeholder="订单运行状态"
          clearable
          style="width: 140px; margin-left: 10px;"
          @change="handleSearch"
        >
          <el-option label="正常运行" value="active" />
          <el-option label="已暂停" value="paused" />
        </el-select>
        <el-date-picker
          v-model="filters.dateRange"
          type="daterange"
          range-separator="至"
          start-placeholder="操作开始"
          end-placeholder="操作结束"
          value-format="yyyy-MM-dd"
          style="margin-left: 10px;"
          @change="handleSearch"
        />
        <el-button type="primary" class="btn-primary" style="margin-left: 10px;" @click="handleSearch">筛选</el-button>
        <el-button class="btn-secondary" style="margin-left: 10px;" @click="resetFilters">重置</el-button>
      </div>

      <el-table :data="tableData" stripe class="deferral-table" style="width: 100%;">
        <el-table-column prop="user_name" label="顾客姓名" width="110" />
        <el-table-column prop="user_phone" label="联系电话" width="130" />
        <el-table-column prop="operation_date" label="延期操作日期" width="120" />
        <el-table-column prop="operator_name" label="延期操作人" width="110" />
        <el-table-column prop="deferred_meal_slot" label="延期选中餐次" width="110" />
        <el-table-column prop="last_meal_date_before" label="延期前最后一餐日期" width="150" />
        <el-table-column prop="last_meal_slot_before" label="延期前时段" width="100" />
        <el-table-column prop="last_meal_date_after" label="延期后最后一餐日期" width="150" />
        <el-table-column prop="last_meal_slot_after" label="延期后时段" width="100" />
      </el-table>

      <el-pagination
        v-if="pagination.total > 0"
        :current-page="pagination.page"
        :page-size="pagination.pageSize"
        :total="pagination.total"
        layout="total, prev, pager, next"
        style="margin-top: 20px; text-align: right;"
        @current-change="handlePageChange"
      />
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'DeferralQuery',
  data() {
    return {
      filters: {
        user_name: '',
        user_phone: '',
        order_id: '',
        meal_run_status: '',
        dateRange: null
      },
      tableData: [],
      pagination: { page: 1, pageSize: 20, total: 0 }
    }
  },
  mounted() {
    this.fetchList()
  },
  methods: {
  async fetchList() {
      const params = {
        page: this.pagination.page,
        pageSize: this.pagination.pageSize,
        user_name: this.filters.user_name || undefined,
        user_phone: this.filters.user_phone || undefined,
        order_id: this.filters.order_id || undefined
      }
      if (Array.isArray(this.filters.dateRange) && this.filters.dateRange.length === 2) {
        params.date_from = this.filters.dateRange[0]
        params.date_to = this.filters.dateRange[1]
      }
      try {
        const resp = await this.$api.get('/admin/meal-schedules/deferrals', { params })
        if (resp && resp.code === 200 && resp.data) {
          this.tableData = resp.data.list || []
          this.pagination.total = resp.data.total || 0
        }
      } catch (e) {
        this.$message.error('加载延期记录失败')
      }
    },
    handleSearch() {
      this.pagination.page = 1
      this.fetchList()
    },
    resetFilters() {
      this.filters = { user_name: '', user_phone: '', order_id: '', meal_run_status: '', dateRange: null }
      this.handleSearch()
    },
    handlePageChange(p) {
      this.pagination.page = p
      this.fetchList()
    },
    handleExport() {
      const params = new URLSearchParams()
      if (this.filters.user_name) params.set('user_name', this.filters.user_name)
      if (this.filters.user_phone) params.set('user_phone', this.filters.user_phone)
      if (Array.isArray(this.filters.dateRange) && this.filters.dateRange.length === 2) {
        params.set('date_from', this.filters.dateRange[0])
        params.set('date_to', this.filters.dateRange[1])
      }
      const token = localStorage.getItem('admin_token') || ''
      const base = this.$api.defaults.baseURL || '/api'
      window.open(`${base}/admin/meal-schedules/deferrals/export?${params.toString()}&token=${encodeURIComponent(token)}`, '_blank')
    }
  }
}
</script>

<style scoped>
.deferral-query {
  padding: 0 4px 24px;
}
.lvyun-profile-banner {
  background: linear-gradient(135deg, #f0f7ff 0%, #e8f4fd 100%);
  border-radius: 12px;
  padding: 24px 28px;
  margin-bottom: 20px;
  border: 1px solid #dbeafe;
}
.lvyun-profile-banner h2 {
  margin: 0 0 8px;
  font-size: 22px;
  color: #1e293b;
}
.lvyun-profile-banner p {
  margin: 0;
  color: #64748b;
  font-size: 14px;
}
.action-card {
  border-radius: 12px;
  border: 1px solid #e2e8f0;
}
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.card-title {
  font-weight: 600;
  font-size: 16px;
}
.filters-row {
  margin-bottom: 16px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.deferral-table {
  border: 1px solid #e2e8f0;
  border-radius: 8px;
}
</style>
